/**
 * Volunteer Management - Shared Constants and Utilities
 */

export const STATUS_CONFIG = {
  active: { label: "Active", color: "bg-green-500" },
  pending: { label: "Pending", color: "bg-yellow-500" },
  inactive: { label: "Inactive", color: "bg-gray-500" },
  on_leave: { label: "On Leave", color: "bg-blue-500" },
  terminated: { label: "Terminated", color: "bg-red-500" }
};

export const ROLE_TYPES = {
  companionship: "Companionship",
  respite: "Respite Care",
  bereavement: "Bereavement Support",
  administrative: "Administrative",
  pet_therapy: "Pet Therapy",
  music_therapy: "Music Therapy",
  veteran: "Veteran Support",
  spiritual: "Spiritual Care"
};

export const COMPLIANCE_CONFIG = {
  background_check: { label: "Background Check", required: true },
  orientation: { label: "Orientation", required: true },
  tb_test: { label: "TB Test", required: true },
  flu_vaccine: { label: "Flu Vaccine", required: false },
  covid_vaccine: { label: "COVID Vaccine", required: false },
  driver_license: { label: "Driver's License", required: false }
};

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const getAuthHeaders = () => ({
  "Authorization": `Bearer ${localStorage.getItem("hospice_token")}`,
  "Content-Type": "application/json"
});
